export default "__VITE_PUBLIC_ASSET__7fac130e__"